/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import './index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import "./globals.css";
import { ThemeProvider } from './context/ThemeContext.jsx'; // Import ThemeProvider
import { AccountDataProvider } from './context/AccountDataProvider.jsx';
import { UserPreferencesProvider } from './context/UserPreferencesContext.jsx';
import { SubscriptionAccessProvider } from './context/SubscriptionAccessContext.jsx';
import { TradeProvider } from './context/TradeProvider.jsx';
import { registerServiceWorker } from './lib/pushNotifications';

// Register service worker for PWA + push notifications without mixed import modes.
if ('serviceWorker' in navigator) {
  registerServiceWorker().catch(() => {});
}

createRoot(document.getElementById('root')).render(
  //<StrictMode>
    <ThemeProvider>
      <UserPreferencesProvider>
        <SubscriptionAccessProvider>
          <TradeProvider>
            <AccountDataProvider>
              <App />
            </AccountDataProvider>
          </TradeProvider>
        </SubscriptionAccessProvider>
      </UserPreferencesProvider>
    </ThemeProvider>
  //</StrictMode>,
)

